import API from "./axios"


// ==========================================
// SEARCH SUGGESTIONS
// ==========================================
export const getSearchSuggestions = (query) => {

  return API.get("/search-suggestions", {
    params: {
      q: query
    }
  })

}



// ==========================================
// SEARCH PRODUCTS
// ==========================================
export const searchProducts = (query, page = 1) => {

  return API.get("/search-products", {
    params: {
      q: query,
      page
    }
  })

}